import BrandSettingActionType from './brandSettingActionType';

export const brandSettingLoader = (loading) => ({
  type: BrandSettingActionType.BRAND_SETTING_LOADER,
  payload: { loading },
});

export const addBrandCurrency = (data) => ({
  type: BrandSettingActionType.ADD_BRAND_CURRENCY,
  payload: { data },
});

export const enableBrandCurrency = (data) => ({
  type: BrandSettingActionType.ENABLE_BRAND_CURRENCY,
  payload: { data },
});

export const setDefaultCurrency = (data) => ({
  type: BrandSettingActionType.SET_DEFAULT_CURRENCY,
  payload: { data },
});

export const changeOrderCurrency = (data) => ({
  type: BrandSettingActionType.CHANGE_ORDER_CURRENCY,
  payload: { data },
});

export const getBrandCountries = (brandId, isLoading) => ({
  type: BrandSettingActionType.GET_BRAND_COUNTRIES,
  payload: { brandId, isLoading },
});

export const saveBrandCountriesData = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_COUNTRIES_DATA,
  payload: { data },
});

export const resetBrandCountriesData = () => ({
  type: BrandSettingActionType.RESET_BRAND_COUNTRIES_DATA,
});

export const addBrandCountry = (data) => ({
  type: BrandSettingActionType.ADD_BRAND_COUNTRY,
  payload: { data },
});

export const enableBrandCountry = (data) => ({
  type: BrandSettingActionType.ENABLE_BRAND_COUNTRY,
  payload: { data },
});

export const setDefaultCountry = (data) => ({
  type: BrandSettingActionType.SET_DEFAULT_COUNTRY,
  payload: { data },
});

export const addBrandLanguage = (data) => ({
  type: BrandSettingActionType.ADD_BRAND_LANGUAGE,
  payload: { data },
});

export const enableBrandLanguage = (data) => ({
  type: BrandSettingActionType.ENABLE_BRAND_LANGUAGE,
  payload: { data },
});

export const setDefaultLanguage = (data) => ({
  type: BrandSettingActionType.SET_DEFAULT_LANGUAGE,
  payload: { data },
});

export const changeOrderLanguage = (data) => ({
  type: BrandSettingActionType.CHANGE_ORDER_LANGUAGE,
  payload: { data },
});

export const setBrandMainSetting = (data) => ({
  type: BrandSettingActionType.SET_BRAND_MAIN_SETTING,
  payload: { data },
});

export const getDomains = (brandId) => ({
  type: BrandSettingActionType.GET_DOMAINS,
  payload: { brandId },
});

export const resetDomains = () => ({
  type: BrandSettingActionType.RESET_DOMAINS,
});

export const saveDomains = (data) => ({
  type: BrandSettingActionType.SAVE_DOMAINS,
  payload: { data },
});

export const addDomain = (data) => ({
  type: BrandSettingActionType.ADD_DOMAIN,
  payload: { data },
});

export const editDomain = (id, data) => ({
  type: BrandSettingActionType.EDIT_DOMAIN,
  payload: { id, data },
});

export const deleteDomain = (id) => ({
  type: BrandSettingActionType.DELETE_DOMAIN,
  payload: { id },
});

export const getSportDomains = (brandId) => ({
  type: BrandSettingActionType.GET_SPORT_DOMAINS,
  payload: { brandId },
});

export const resetSportDomains = () => ({
  type: BrandSettingActionType.RESET_SPORT_DOMAINS,
});

export const setSportMainDomain = (id, brandId) => ({
  type: BrandSettingActionType.SET_SPORT_MAIN_DOMAIN,
  payload: { id, brandId },
});

export const addSportDomain = (data) => ({
  type: BrandSettingActionType.ADD_SPORT_DOMAIN,
  payload: { data },
});

export const saveSportDomains = (data) => ({
  type: BrandSettingActionType.SAVE_SPORT_DOMAINS,
  payload: { data },
});

export const editSportDomain = (id, data) => ({
  type: BrandSettingActionType.EDIT_SPORT_DOMAIN,
  payload: { id, data },
});

export const deleteSportDomain = (id) => ({
  type: BrandSettingActionType.DELETE_SPORT_DOMAIN,
  payload: { id },
});

export const getBrandGeneralSettings = (params) => ({
  type: BrandSettingActionType.GET_BRAND_GENERAL_SETTINGS,
  payload: { params },
});

export const saveBrandGeneralSettings = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_GENERAL_SETTINGS,
  payload: { data },
});

export const addBrandGeneralSettings = (data) => ({
  type: BrandSettingActionType.ADD_BRAND_GENERAL_SETTINGS,
  payload: { data },
});

export const getBrandCaptchaSettings = (brandId) => ({
  type: BrandSettingActionType.GET_BRAND_CAPTCHA_SETTINGS,
  payload: { brandId },
});

export const saveBrandCaptchaSettings = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_CAPTCHA_SETTINGS,
  payload: { data },
});

export const editBrandCaptchaSettings = (brandId, data) => ({
  type: BrandSettingActionType.EDIT_BRAND_CAPTCHA_SETTINGS,
  payload: { brandId, data },
});

export const resetBrandCaptchaSettings = () => ({
  type: BrandSettingActionType.RESET_BRAND_CAPTCHA_SETTINGS,
});

export const addBrandDepositConversion = (data) => ({
  type: BrandSettingActionType.ADD_BRAND_DEPOSIT_CONVERSION,
  payload: { data },
});

export const addBrandWithdrawalConversion = (data) => ({
  type: BrandSettingActionType.ADD_BRAND_WITHDRAWAL_CONVERSION,
  payload: { data },
});

export const addBrandOtherConversion = (data) => ({
  type: BrandSettingActionType.ADD_BRAND_OTHER_CONVERSION,
  payload: { data },
});

export const getBrandDepositConversion = (brandId, params) => ({
  type: BrandSettingActionType.GET_BRAND_DEPOSIT_CONVERSION,
  payload: { brandId, params },
});

export const getBrandWithdrawalConversion = (brandId, params) => ({
  type: BrandSettingActionType.GET_BRAND_WITHDRAWAL_CONVERSION,
  payload: { brandId, params },
});

export const saveBrandConversion = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_CONVERSION,
  payload: { data },
});

export const resetBrandConversion = () => ({
  type: BrandSettingActionType.RESET_BRAND_CONVERSION,
});

export const getBrandOtherConversion = (brandId, params) => ({
  type: BrandSettingActionType.GET_BRAND_OTHER_CONVERSION,
  payload: { brandId, params },
});

export const editBrandDepositConversion = (data) => ({
  type: BrandSettingActionType.EDIT_BRAND_DEPOSIT_CONVERSION,
  payload: { data },
});

export const editBrandWithdrawalConversion = (data) => ({
  type: BrandSettingActionType.EDIT_BRAND_WITHDRAWAL_CONVERSION,
  payload: { data },
});

export const editBrandOtherConversion = (data) => ({
  type: BrandSettingActionType.EDIT_BRAND_OTHER_CONVERSION,
  payload: { data },
});

export const deleteBrandDepositConversion = (brandId, params) => ({
  type: BrandSettingActionType.DELETE_BRAND_DEPOSIT_CONVERSION,
  payload: { brandId, params },
});

export const deleteBrandWithdrawalConversion = (brandId, params) => ({
  type: BrandSettingActionType.DELETE_BRAND_WITHDRAWAL_CONVERSION,
  payload: { brandId, params },
});

export const deleteBrandOtherConversion = (brandId, params) => ({
  type: BrandSettingActionType.DELETE_BRAND_OTHER_CONVERSION,
  payload: { brandId, params },
});

export const getBrandDepositConversions = (brandId, params) => ({
  type: BrandSettingActionType.GET_BRAND_DEPOSIT_CONVERSIONS,
  payload: { brandId, params },
});

export const saveBrandDepositConversions = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_DEPOSIT_CONVERSIONS,
  payload: { data },
});

export const resetBrandDepositConversions = () => ({
  type: BrandSettingActionType.RESET_BRAND_DEPOSIT_CONVERSIONS,
});

export const getBrandWithdrawalConversions = (brandId, params) => ({
  type: BrandSettingActionType.GET_BRAND_WITHDRAWAL_CONVERSIONS,
  payload: { brandId, params },
});

export const saveBrandWithdrawalConversions = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_WITHDRAWAL_CONVERSIONS,
  payload: { data },
});

export const resetBrandWithdrawalConversions = () => ({
  type: BrandSettingActionType.RESET_BRAND_WITHDRAWAL_CONVERSIONS,
});

export const getBrandOtherConversions = (brandId, params) => ({
  type: BrandSettingActionType.GET_BRAND_OTHER_CONVERSIONS,
  payload: { brandId, params },
});

export const saveBrandOtherConversions = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_OTHER_CONVERSIONS,
  payload: { data },
});

export const resetBrandOtherConversions = () => ({
  type: BrandSettingActionType.RESET_BRAND_OTHER_CONVERSIONS,
});

export const importBrandDepositConversion = (brandId, data) => ({
  type: BrandSettingActionType.IMPORT_BRAND_DEPOSIT_CONVERSION,
  payload: { brandId, data },
});

export const importBrandWithdrawalConversion = (brandId, data) => ({
  type: BrandSettingActionType.IMPORT_BRAND_WITHDRAWAL_CONVERSION,
  payload: { brandId, data },
});

export const importBrandOtherConversion = (brandId, data) => ({
  type: BrandSettingActionType.IMPORT_BRAND_OTHER_CONVERSION,
  payload: { brandId, data },
});

export const exportBrandDepositConversion = (brandId, params) => ({
  type: BrandSettingActionType.EXPORT_BRAND_DEPOSIT_CONVERSION,
  payload: { brandId, params },
});

export const exportBrandWithdrawalConversion = (brandId, params) => ({
  type: BrandSettingActionType.EXPORT_BRAND_WITHDRAWAL_CONVERSION,
  payload: { brandId, params },
});

export const exportBrandOtherConversion = (brandId, params) => ({
  type: BrandSettingActionType.EXPORT_BRAND_OTHER_CONVERSION,
  payload: { brandId, params },
});

export const getBrandDepositConversionLogs = (brandId, params) => ({
  type: BrandSettingActionType.GET_BRAND_DEPOSIT_CONVERSION_LOGS,
  payload: { brandId, params },
});

export const saveBrandConversionLogs = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_CONVERSION_LOGS,
  payload: { data },
});

export const getBrandWithdrawalConversionLogs = (brandId, params) => ({
  type: BrandSettingActionType.GET_BRAND_WITHDRAWAL_CONVERSION_LOGS,
  payload: { brandId, params },
});

export const getBrandOtherConversionLogs = (brandId, params) => ({
  type: BrandSettingActionType.GET_BRAND_OTHER_CONVERSION_LOGS,
  payload: { brandId, params },
});

export const resetBrandConversionLogs = () => ({
  type: BrandSettingActionType.RESET_BRAND_CONVERSION_LOGS,
});

export const getBrandStandardSettings = (brandId, isLoading) => ({
  type: BrandSettingActionType.GET_BRAND_STANDARD_SETTINGS,
  payload: { brandId, isLoading },
});

export const saveBrandStandardSettings = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_STANDARD_SETTINGS,
  payload: { data },
});

export const editBrandStandardSettings = (brandId, data, enabled, name) => ({
  type: BrandSettingActionType.EDIT_BRAND_STANDARD_SETTINGS,
  payload: {
    brandId,
    data,
    enabled,
    name,
  },
});

export const resetBrandStandardSettings = () => ({
  type: BrandSettingActionType.RESET_BRAND_STANDARD_SETTINGS,
});

export const getBrandBlockedCountries = (brandId, isLoading) => ({
  type: BrandSettingActionType.GET_BRAND_BLOCKED_COUNTRIES,
  payload: { brandId, isLoading },
});

export const saveBrandBlockedCountries = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_BLOCKED_COUNTRIES,
  payload: { data },
});

export const resetBrandBlockedCountries = () => ({
  type: BrandSettingActionType.RESET_BRAND_BLOCKED_COUNTRIES,
});

export const changeBrandBlockedCountries = (brandId, data) => ({
  type: BrandSettingActionType.CHANGE_BRAND_BLOCKED_COUNTRIES,
  payload: { brandId, data },
});

export const getBrandWhitelistedIPs = (brandId) => ({
  type: BrandSettingActionType.GET_BRAND_WHITELISTED_IPS,
  payload: { brandId },
});

export const saveBrandWhitelistedIPs = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_WHITELISTED_IPS,
  payload: { data },
});

export const resetBrandWhitelistedIps = () => ({
  type: BrandSettingActionType.RESET_BRAND_WHITELISTED_IPS,
});

export const addBrandWhitelistedIP = (brandId, data) => ({
  type: BrandSettingActionType.ADD_BRAND_WHITELISTED_IP,
  payload: { brandId, data },
});

export const deleteBrandWhitelistedIP = (brandId, data) => ({
  type: BrandSettingActionType.DELETE_BRAND_WHITELISTED_IP,
  payload: { brandId, data },
});

export const resetBrandSettings = () => ({
  type: BrandSettingActionType.RESET_BRAND_SETTINGS,
});

export const addDomainRedirectUrl = (brandId, data) => ({
  type: BrandSettingActionType.ADD_DOMAIN_REDIRECT_URL,
  payload: { brandId, data },
});

export const deleteDomainRedirectUrl = (brandId, params) => ({
  type: BrandSettingActionType.DELETE_DOMAIN_REDIRECT_URL,
  payload: { brandId, params },
});

export const getBrandSportsBookLayouts = (brandId) => ({
  type: BrandSettingActionType.GET_BRAND_SPORTSBOOK_LAYOUTS,
  payload: { brandId },
});

export const saveBrandSportsBookLayouts = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_SPORTSBOOK_LAYOUTS,
  payload: { data },
});

export const resetBrandSportsBookLayouts = () => ({
  type: BrandSettingActionType.RESET_BRAND_SPORTSBOOK_LAYOUTS,
});

export const changeSportsBookTemplatesCallEndedStatus = (status) => ({
  type: BrandSettingActionType.CHANGE_BRAND_SPORTSBOOK_LAYOUTS_CALL_ENDED_STATUS,
  payload: { status },
});

export const activateBrandSportsBookProvider = (brandId) => ({
  type: BrandSettingActionType.ACTIVATE_BRAND_SPORTSBOOK_PROVIDER,
  payload: { brandId },
});

export const setBrandSportsBookDefaultTemplate = (brandId, templateId) => ({
  type: BrandSettingActionType.SET_BRAND_SPORTSBOOK_DEFAULT_TEMPLATE,
  payload: { brandId, templateId },
});

export const activateBrandRgs = (brandId) => ({
  type: BrandSettingActionType.ACTIVATE_BRAND_RGS,
  payload: { brandId },
});

export const getBrandSportsBookSettings = (brandId) => ({
  type: BrandSettingActionType.GET_BRAND_SPORTSBOOK_SETTINGS,
  payload: { brandId },
});

export const saveBrandSportsBookSettings = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_SPORTSBOOK_SETTINGS,
  payload: { data },
});

export const resetBrandSportsBookSettings = () => ({
  type: BrandSettingActionType.RESET_BRAND_SPORTSBOOK_SETTINGS,
});

export const enableBrandSportsBookPrematchTopMatches = (brandId, params, name) => ({
  type: BrandSettingActionType.ENABLE_BRAND_SPORTSBOOK_PREMATCH_TOP_MATCHES,
  payload: { brandId, params, name },
});

export const enableBrandSportsBookPrematchTotalTopMatches = (brandId, params, name) => ({
  type: BrandSettingActionType.ENABLE_BRAND_SPORTSBOOK_PREMATCH_TOTAL_TOP_MATCHES,
  payload: { brandId, params, name },
});

export const enableBrandSportsBookLivePrematchTopMatches = (brandId, params, name) => ({
  type: BrandSettingActionType.ENABLE_BRAND_SPORTSBOOK_LIVE_PREMATCH_TOP_MATCHES,
  payload: { brandId, params, name },
});

export const enableBrandSportsBookLiveTopMatches = (brandId, params, name) => ({
  type: BrandSettingActionType.ENABLE_BRAND_SPORTSBOOK_LIVE_TOP_MATCHES,
  payload: { brandId, params, name },
});

export const enableBrandSportsBookJackpot = (brandId, params, name) => ({
  type: BrandSettingActionType.ENABLE_BRAND_SPORTSBOOK_JACKPOT,
  payload: { brandId, params, name },
});

export const enableBrandMultiBet = (brandId, params, name) => ({
  type: BrandSettingActionType.ENABLE_BRAND_MULTI_BET,
  payload: { brandId, params, name },
});

export const enableBrandSportsBookSuperPromotion = (brandId, params, name) => ({
  type: BrandSettingActionType.ENABLE_BRAND_SPORTSBOOK_SUPER_PROMOTION,
  payload: { brandId, params, name },
});

export const enableBrandSportsBookSectionScrolling = (brandId, params, name) => ({
  type: BrandSettingActionType.ENABLE_BRAND_SPORTSBOOK_SECTION_SCROLLING,
  payload: { brandId, params, name },
});

export const enableBrandSportsBookTournamentBalance = (brandId, params, name) => ({
  type: BrandSettingActionType.ENABLE_BRAND_SPORTSBOOK_TOURNAMENT_BALANCE,
  payload: { brandId, params, name },
});

export const changeBrandSportsBookMobileIntegrationType = (brandId, params, name) => ({
  type: BrandSettingActionType.CHANGE_BRAND_SPORTSBOOK_MOBILE_INTEGRATION_TYPE,
  payload: { brandId, params, name },
});

export const changeBrandSportsBookOddsFormat = (brandId, params, name) => ({
  type: BrandSettingActionType.CHANGE_BRAND_SPORTSBOOK_ODDS_FORMAT,
  payload: { brandId, params, name },
});

export const enableBrandSportsBookColorInheritance = (brandId, params, name) => ({
  type: BrandSettingActionType.ENABLE_BRAND_SPORTSBOOK_COLOR_INHERITANCE,
  payload: { brandId, params, name },
});

export const getBrandSportsBookWalletsSettings = (params) => ({
  type: BrandSettingActionType.GET_BRAND_SPORTSBOOK_WALLETS_SETTINGS,
  payload: { params },
});
export const saveBrandSportsBookWalletsSettings = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_SPORTSBOOK_WALLETS_SETTINGS,
  payload: { data },
});
export const resetBrandSportsBookWalletsSettings = () => ({
  type: BrandSettingActionType.RESET_BRAND_SPORTSBOOK_WALLETS_SETTINGS,
});
export const editBrandSportsBookWalletsSettings = (data, brandId) => ({
  type: BrandSettingActionType.EDIT_BRAND_SPORTSBOOK_WALLETS_SETTINGS,
  payload: { data, brandId },
});

export const getBrandCasinoProductSettings = (brandId) => ({
  type: BrandSettingActionType.GET_BRAND_CASINO_PRODUCT_SETTINGS,
  payload: { brandId },
});

export const saveBrandCasinoProductSettings = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_CASINO_PRODUCT_SETTINGS,
  payload: { data },
});

export const resetBrandCasinoProductSettings = () => ({
  type: BrandSettingActionType.RESET_BRAND_CASINO_PRODUCT_SETTINGS,
});

export const editBrandCasinoProductSettings = (brandId, data, param, name) => ({
  type: BrandSettingActionType.EDIT_BRAND_CASINO_PRODUCT_SETTINGS,
  payload: {
    brandId,
    data,
    param,
    name,
  },
});

export const getBrandCasinoProductJackpotSettings = (brandId) => ({
  type: BrandSettingActionType.GET_BRAND_CASINO_PRODUCT_JACKPOT_SETTINGS,
  payload: { brandId },
});
export const saveBrandCasinoProductJackpotSettings = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_CASINO_PRODUCT_JACKPOT_SETTINGS,
  payload: { data },
});
export const resetBrandCasinoProductJackpotSettings = () => ({
  type: BrandSettingActionType.RESET_BRAND_CASINO_PRODUCT_JACKPOT_SETTINGS,
});
export const changeBrandCasinoProductJackpotSettingsEndedStatus = (status) => ({
  type: BrandSettingActionType.CHANGE_BRAND_CASINO_PRODUCT_JACKPOT_SETTINGS_ENDED_STATUS,
  payload: { status },
});
export const editBrandCasinoProductJackpotSettings = (brandId, data) => ({
  type: BrandSettingActionType.EDIT_BRAND_CASINO_PRODUCT_JACKPOT_SETTINGS,
  payload: {
    brandId,
    data,
  },
});

export const getBrandCasinoProductWalletsSettings = (params) => ({
  type: BrandSettingActionType.GET_BRAND_CASINO_PRODUCT_WALLETS_SETTINGS,
  payload: { params },
});
export const saveBrandCasinoProductWalletsSettings = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_CASINO_PRODUCT_WALLETS_SETTINGS,
  payload: { data },
});
export const resetBrandCasinoProductWalletsSettings = () => ({
  type: BrandSettingActionType.RESET_BRAND_CASINO_PRODUCT_WALLETS_SETTINGS,
});
export const editBrandCasinoProductWalletsSettings = (data, brandId) => ({
  type: BrandSettingActionType.EDIT_BRAND_CASINO_PRODUCT_WALLETS_SETTINGS,
  payload: { data, brandId },
});

export const getBrandCurrencyFormat = (brandId) => ({
  type: BrandSettingActionType.GET_BRAND_CURRENCY_FORMAT,
  payload: { brandId },
});

export const saveBrandCurrencyFormat = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_CURRENCY_FORMAT,
  payload: { data },
});

export const resetBrandCurrencyFormat = () => ({
  type: BrandSettingActionType.RESET_BRAND_CURRENCY_FORMAT,
});

export const editBrandCurrencyFormat = (brandId, data) => ({
  type: BrandSettingActionType.EDIT_BRAND_CURRENCY_FORMAT,
  payload: {
    brandId,
    data,
  },
});

export const getBrandInactivitySettings = (brandId) => ({
  type: BrandSettingActionType.GET_BRAND_INACTIVITY_SETTINGS,
  payload: { brandId },
});

export const saveBrandInactivitySettings = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_INACTIVITY_SETTINGS,
  payload: { data },
});

export const resetBrandInactivitySettings = () => ({
  type: BrandSettingActionType.RESET_BRAND_INACTIVITY_SETTINGS,
});

export const editBrandInactivitySettings = (brandId, data) => ({
  type: BrandSettingActionType.EDIT_BRAND_INACTIVITY_SETTINGS,
  payload: {
    brandId,
    data,
  },
});

export const getBrandSportStatusSettings = (brandId) => ({
  type: BrandSettingActionType.GET_BRAND_SPORT_STATUS_SETTINGS,
  payload: { brandId },
});

export const saveBrandSportStatusSettings = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_SPORT_STATUS_SETTINGS,
  payload: { data },
});

export const resetBrandSportStatusSettings = () => ({
  type: BrandSettingActionType.RESET_BRAND_SPORT_STATUS_SETTINGS,
});

export const editBrandSportStatusSettings = (brandId, id, data, name) => ({
  type: BrandSettingActionType.EDIT_BRAND_SPORT_STATUS_SETTINGS,
  payload: {
    brandId,
    id,
    data,
    name,
  },
});

export const addBrandNationality = (data) => ({
  type: BrandSettingActionType.ADD_BRAND_NATIONALITY,
  payload: { data },
});

export const changeNationalityStatus = (data) => ({
  type: BrandSettingActionType.CHANGE_NATIONALITY_STATUS,
  payload: { data },
});

export const setDefaultNationality = (data) => ({
  type: BrandSettingActionType.SET_DEFAULT_NATIONALITY,
  payload: { data },
});

export const getBrandNationalities = (brandId, isLoading, isResource = true) => ({
  type: BrandSettingActionType.GET_BRAND_NATIONALITIES,
  payload: { brandId, isLoading, isResource },
});

export const saveBrandNationalities = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_NATIONALITIES,
  payload: { data },
});

export const resetBrandNationalities = () => ({
  type: BrandSettingActionType.RESET_BRAND_NATIONALITIES,
});

export const saveBrandNationalitiesData = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_NATIONALITIES_DATA,
  payload: { data },
});

export const resetBrandNationalitiesData = () => ({
  type: BrandSettingActionType.RESET_BRAND_NATIONALITIES_DATA,
});

export const changeOrderNationality = (data) => ({
  type: BrandSettingActionType.CHANGE_ORDER_NATIONALITY,
  payload: { data },
});

export const getBrandMobileCodes = (params, isLoading) => ({
  type: BrandSettingActionType.GET_BRAND_MOBILE_CODES,
  payload: { params, isLoading },
});

export const saveBrandMobileCodes = (data) => ({
  type: BrandSettingActionType.SAVE_BRAND_MOBILE_CODES,
  payload: { data },
});

export const resetBrandMobileCodes = () => ({
  type: BrandSettingActionType.RESET_BRAND_MOBILE_CODES,
});

export const addBrandMobileCode = (data) => ({
  type: BrandSettingActionType.ADD_BRAND_MOBILE_CODE,
  payload: { data },
});

export const deleteBrandMobileCode = (id, params) => ({
  type: BrandSettingActionType.DELETE_BRAND_MOBILE_CODE,
  payload: { id, params },
});
